export const BookingStatusWithID = {
    BOOKING_GENERATED: 0,      // Waiting for Center to Accept
    CENTER_ACCEPTED: 1,        // Booking Confirmed (Center Accepted)
    OPERATOR_ASSIGNED: 2,      // Operator Assigned
    OPERATOR_STARTED: 3,       // Operator Started Journey
    XRAY_DONE: 4,              // X-ray Procedure Completed
    XRAY_UPLOADED: 5,          // X-ray Uploaded
    DR_ASSIGNED: 6,            // Radiologist Assigned
    BOOKING_DONE: 7            // Report Uploaded (Booking Done)
};

export const BookingStatusText = {
    [BookingStatusWithID.BOOKING_GENERATED]: "Booking Generated",
    [BookingStatusWithID.CENTER_ACCEPTED]: "Center Accepted",
    [BookingStatusWithID.OPERATOR_ASSIGNED]: "Operator Assigned",
    [BookingStatusWithID.OPERATOR_STARTED]: "Operator Started",
    [BookingStatusWithID.XRAY_DONE]: "X-ray Done",
    [BookingStatusWithID.XRAY_UPLOADED]: "X-ray Uploaded",
    [BookingStatusWithID.DR_ASSIGNED]: "Assign Radiologist",
    [BookingStatusWithID.BOOKING_DONE]: "Booking Done"
};
